import {loadableReady} from '@loadable/component'
import * as Sentry from '@sentry/react'
import {createBrowserHistory} from 'history'
import React from 'react'
import {hydrate} from 'react-dom'
import {I18nextProvider} from 'react-i18next'
import {Provider} from 'react-redux'
import {renderRoutes} from 'react-router-config'
import {BrowserRouter} from 'react-router-dom'

import App from '~/App'
import i18n, {i18nInitPromise} from '~/lib/i18n'
import getRoutes from '~/routes'
import {createStore, setStore} from '~/stores'
import {restoreDeviceInfoCache} from '~/utils/deviceInfoCache'
import sentry from '~/utils/sentry'

import PendingNavDataLoader from './PendingNavDataLoader'

import 'core-js/stable'
import './index.css'

sentry()

const history = createBrowserHistory()
export {history}

const bootstrapState = window.APP_INITIAL_STATE || {}
const cachedDeviceInfo = restoreDeviceInfoCache()
const currentDeviceInfo = bootstrapState.deviceInfo
if (cachedDeviceInfo && !currentDeviceInfo?.h_m && !currentDeviceInfo?.token) {
  bootstrapState.deviceInfo = {
    ...currentDeviceInfo,
    ...cachedDeviceInfo,
  }
}

const store = createStore(bootstrapState)
window.APP_INITIAL_STATE = null
window.store = store
const routes = getRoutes(store)
setStore(store)

const AppWithSentry = Sentry.withProfiler(App, {name: 'cupid-h5'})
const application = (
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <BrowserRouter>
        <PendingNavDataLoader store={store} routes={routes}>
          {() => (
            <AppWithSentry
              skipWindowLoad={['/candyRecharge', '/jellyOrders'].includes(
                window.location.pathname
              )}
            >
              {renderRoutes(routes)}
            </AppWithSentry>
          )}
        </PendingNavDataLoader>
      </BrowserRouter>
    </Provider>
  </I18nextProvider>
)

const loadableReadyPromise = new Promise<void>((resolve) => {
  loadableReady(() => {
    resolve()
  })
})

// 页面大量使用非响应式的 i18next.t()，必须等目标语言加载成功后再渲染；
// 不能通过超时或忽略初始化失败继续 hydrate，否则会出现错误语言或混合语言。
Promise.all([loadableReadyPromise, i18nInitPromise])
  .then(() => {
    const root = document.getElementById('app')
    hydrate(application, root)
  })
  .catch((error) => {
    Sentry.captureException(error)
  })
